export const APP_STARTUP_LOADING = "APP_STARTUP_LOADING";
export const APP_STARTUP_COMPLETED = "APP_STARTUP_COMPLETED";
export const USER_AUTH_CHANGE = "USER_AUTH_CHANGE";
export const SAVE_SESSION_PERSISTOR = "SAVE_SESSION_PERSISTOR";
export const USER_SESSION_EXPIRED = "USER_SESSION_EXPIRED";
